// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__14dAa","dragIcon":"Choice_dragIcon__22Slb","left":"Choice_left__2mj6P","input":"Choice_input__3FfUD"};